import { render } from "./CallCenterModule.vue?vue&type=template&id=7db1f829&scoped=true"
import script from "./CallCenterModule.vue?vue&type=script&lang=js"
export * from "./CallCenterModule.vue?vue&type=script&lang=js"

import "./CallCenterModule.vue?vue&type=style&index=0&id=7db1f829&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db1f829"]])

export default __exports__